export default {
  "请输入手机号或用户名": "请输入手机号或用户名",
  "请输入密码": "请输入密码",
  "自动登录": "自动登录",
  "游戏试玩": "游戏试玩",
  "忘记密码": "忘记密码",
  "登录账户": "登录账户",
  "联系客服": "联系客服",
  "注册账户": "注册账户",
  "请选择你的语言": "请选择你的语言",
  "选择你的语言": "Choose your language",
  "英语": "English",
  "简体中文": "简体中文",
  "繁体中文": "繁体中文",
  "请输入确认密码": "请输入确认密码",
  "推荐人": "推荐人",
  "请输入验证码": "请输入验证码",
  "注册": "注册",
  "登录": "登录",
  "返回登录": "返回登录",
  "复制成功": "复制成功",
  "客服": "客服",
  "大厅": "大厅",
  "发现": "发现",
  "优惠": "优惠",
  "我的": "我的",
  "会话": "会话",
  "公告通知": "公告通知",
  "上下分如有问题请及时联系客服": "上下分如有问题请及时联系客服",
  "在线客服": "在线客服",
  "提供各类问题疑难排解": "提供各类问题疑难排解",
  "Telegram客服": "Telegram客服",
  "Signal客服": "Signal客服",
  "Signal客服号码": "+1(971) 427 1149",
  "消息中心": "消息中心",
  "公告": "公告",
  "站内信": "站内信",
  "没有更多了": "没有更多了",
  "请先登录或者注册": "请先登录或者注册",
  "充值": "充值",
  "转账": "转账",
  "提现": "提现",
  "IOS用户注意": "iOS用户注意",
  "尊敬的U8会员您好": "尊敬的U8会员您好",
  "系统内容1": "U8国际iOS新版APP已完成修复并正式上线，现已开放下载。",
  "系统内容2": "但为确保永久访问稳定，建议您优先使用Safari浏览器打开",
  "系统内容3": "点击底部 📤“分享”按钮 → 选择 “添加到主屏幕”，即可快捷进入平台。",
  "系统内容4": "如需使用APP，请前往官网",
  "系统内容5": "首页，点击右上角【点击下载】按钮获取最新版。",
  "系统内容6": "如有疑问，请联系官方客服",
  "系统内容7": "协助处理。",
  "系统内容8": "感谢您的支持与理解！",
  "系统内容9": "U8国际运营团队",
  "公平": "公平",
  "公正": "公正",
  "公开": "公开",
  "官方投注机器人":  "官方投注机器人",
  "系统内容10": "直接进行游戏、充值、提现等操作。",
  "搜索": "搜索",
  "系统内容11": "感谢您的理解与支持，祝您游戏愉快！",
  "今日不再弹出": "今日不再弹出",
  "添加": "添加",
  "到手机主页屏幕": "到手机主页屏幕",
  "选择分享按钮": "到手机主页屏幕",
  "点击": "点击",
  "加至主画面": "加至主画面",
  "点击「加入」按钮": "点击「加入」按钮",
  "存款": "存款",
  "网银转账": "网银转账",
  "微信": "微信",
  "支付宝": "支付宝",
  "收款账号": "收款账号",
  "复制": "复制",
  "银行户名": "银行户名",
  "开户行": "开户行",
  "银行地址": "银行地址",
  "开户银行": "开户银行",
  "选择开户银行": "选择开户银行",
  "存款人姓名": "存款人姓名",
  "请输入存款人姓名": "请输入存款人姓名",
  "请务必输入正确的存款人姓名": "为及时到账，请务必输入正确的存款人姓名",
  "银行卡号": "银行卡号",
  "请输入银行卡号": "请输入银行卡号",
  "开户行地址": "开户行地址",
  "请输入开户行地址": "请输入开户行地址",
  "请输入银行开户行地址": "请输入银行开户行地址",
  "存款金额": "存款金额",
  "请输入取款金额": "请输入取款金额",
  "元": "元",
  "USDT价格稳定": "USDT价格稳定",
  "流通性高": "流通性高",
  "不受监管": "不受监管",
  "了解更多": "了解更多",
  "绑定协议地址": "绑定协议地址",
  "交易所划转": "交易所划转",
  "完成取款": "完成取款",
  "钱包协议": "钱包协议",
  "温馨提示": "温馨提示",
  "温馨提示内容": "请选择正确的USDT协议付款，若您选择错误的协议付款，平台将无法收到您的付款，为此我们不承担任何负责！",
  "立即存款": "立即存款",
  "存款遇到问题": "存款遇到问题",
  "联系": "联系",
  "人工客服": "人工客服",
  "解决": "解决",
  "银行类型": "银行类型",
  "请输入银行类型": "请输入银行类型",
  "请输入金额区间": "请输入金额在{min_price}-{max_price}之间！",
  "等待后台审核": "提交成功，等待后台审核",
  "场馆转账": "场馆转账",
  "余额自动转入": "余额自动转入",
  "启用后余额自动转入转出游戏场馆": "启用后余额自动转入转出游戏场馆",
  "请输入转账金额": "请输入转账金额",
  "全部转入": "全部转入",
  "可转账金额": "可转账金额",
  "确认转账": "确认转账",
  "场馆余额明细": "场馆余额明细",
  "点击查看全部场馆余额": "点击查看全部场馆余额",
  "主钱包": "主钱包",
  "一键取回": "一键取回",
  "收起": "收起",
  "展开": "展开",
  "请输入操作金额": "请输入操作金额",
  "场馆内钱包不支持互转": "场馆内钱包不支持互转",
  "操作成功": "操作成功",
  "VIP特权": "VIP特权",
  "已达标": "已达标",
  "未达标": "未达标",
  "累计存款": "累计存款",
  "流水要求": "流水要求",
  "VIP最高返水比例": "VIP最高返水比例",
  "VIP等级": "VIP等级",
  "真人": "真人",
  "体育": "体育",
  "电竞": "电竞",
  "棋牌": "棋牌",
  "电子": "电子",
  "彩票": "彩票",
  "活动规则": "活动规则",
  "晋升标准": "晋升标准",
  "规则内容1": "会员的累计存款以及累计流水达到相应级别的要求，即可在次日24点前晋级相应VIP等级。",
  "晋升顺序": "晋升顺序",
  "规则内容2": "VIP等级达到相应的要求可每天晋升一级，但VIP等级不可越级晋升。",
  "保级要求": "保级要求",
  "规则内容3": "会员在达到某VIP等级后，90天内投注需要完成保级流水要求。如果在此期间完成晋升，保级要求重新按照当前等级计算。",
  "降级标准": "降级标准",
  "规则内容4": "如果会员在一个季度（90天计算）内没有完成相应的保级要求流水，系统会自动降级一个等级，相应的返水及其它优惠也会随之调整至降级后的等级。",
  "VIP返水": "VIP返水",
  "规则内容5": "VIP返水优惠发放金额根据会员当天北京时间00:00—23:59之间的有效投注进行计算，当天所有的投注额返水将在注单结算当天结束后24小时内发放到福利中心，进入个人中心点击福利中心进行手动领取。（VIP返水1倍流水即可提款）",
  "规则内容6": "欧宝娱乐保留对活动的修改，停止及最终解释权",
  "取款": "取款",
  "银行卡取款": "银行卡取款",
  "钱包金额": "钱包金额",
  "一键回收": "一键回收",
  "中心钱包": "中心钱包",
  "游戏钱包": "游戏钱包",
  "选择USDT地址": "选择USDT地址",
  "请选择USDT地址": "请选择USDT地址",
  "添加USDT地址": "添加USDT地址",
  "打码量": "打码量",
  "取款金额": "取款金额",
  "最大金额": "最大金额",
  "支付密码": "支付密码",
  "请输入支付密码": "请输入支付密码",
  "每笔手续费": "每笔手续费",
  "折合USDT": "折合USDT",
  "参考汇率": "参考汇率",
  "实时变化": "实时变化",
  "实际到账": "实际到账",
  "选择银行卡": "选择银行卡",
  "请选择银行卡": "请选择银行卡",
  "添加银行卡": "添加银行卡",
  "立即取款": "立即取款",
  "取款遇到问题": "取款遇到问题",
  "真实姓名": "真实姓名",
  "绑定真实姓名后不可修改": "绑定真实姓名后不可修改",
  "确认修改": "确认修改",
  "请选择您要提现到的银行卡": "请选择您要提现到的银行卡",
  "单笔取款不能低于100元": "单笔取款不能低于100元",
  "请输入您的支付密码": "请输入您的支付密码",
  "请填写用户实名信息": "请填写用户实名信息",
  "提交成功": "提交成功",
  "优惠活动": "优惠活动",
  "全部优惠": "全部优惠",
  "限时活动": "限时活动",
  "新人首存": "新人首存",
  "日常活动": "日常活动",
  "暂未设置签名": "暂未设置签名",
  "账户总资产": "账户总资产",
  "我的钱包": "我的钱包",
  "账户明细": "账户明细",
  "投注记录": "投注记录",
  "安全设置": "安全设置",
  "我的等级": "我的等级",
  "VIP中心": "VIP中心",
  "邀请好友": "邀请好友",
  "推荐送礼金": "推荐送礼金",
  "官方公告": "官方公告",
  "坐收盈利": "坐收盈利",
  "合营计划": "合营计划",
  "加入我们": "加入我们",
  "月入百万": "月入百万",
  "NG扑克": "NG扑克",
  "活动中心": "活动中心",
  "平台优惠回馈活动": "平台优惠回馈活动",
  "输赢比例": "输赢比例",
  "功能设置": "功能设置",
  "反水比例": "反水比例",
  "反水中心": "反水中心",
  "修改登录密码": "修改登录密码",
  "个人资料": "个人资料",
  "个人头像": "个人头像",
  "用户名": "用户名",
  "请输入用户名": "请输入用户名",
  "请输入真实姓名": "请输入真实姓名",
  "出生日期": "出生日期",
  "请选择出入日期": "请选择出入日期",
  "手机号码": "手机号码",
  "绑定手机号保障账号安全": "绑定手机号，保障账号安全",
  "电子邮箱": "电子邮箱",
  "绑定邮箱保护账号安全": "绑定邮箱保护账号安全",
  "请输入正确手机号": "请输入正确手机号",
  "请输入正确邮箱号": "请输入正确邮箱号",
  "请输入正确的日期格式": "请输入正确的日期格式",
  "邀请链接": "邀请链接",
  "立即邀请": "立即邀请",
  "礼金介绍": "礼金介绍",
  "明细记录": "明细记录",
  "下级概览": "下级概览",
  "下级成员统计": "下级成员统计",
  "本月新增": "本月新增",
  "本月活跃成员": "本月活跃成员",
  "本月有效活跃": "本月有效活跃",
  "今日新增": "今日新增",
  "今日活跃": "今日活跃",
  "本月新增有效会员": "本月新增有效会员",
  "今日存款": "今日存款",
  "数据列表": "数据列表",
  "礼金记录": "礼金记录",
  "好友明细": "好友明细",
  "重置": "重置",
  "查询": "查询",
  "日期": "日期",
  "礼金": "礼金",
  "备注": "备注",
  "保存链接": "保存链接",
  "保存图片": "保存图片",
  "保存二维码": "保存二维码",
  "取消": "取消",
  "链接已复制到剪贴板": "链接已复制到剪贴板",
  "复制链接失败": "复制链接失败",
  "合营部": "合营部",
  "立即咨询": "立即咨询",
  "咨询": "咨询",
  "联系方式": "联系方式",
  "请输入您的联系方式": "请输入您的联系方式",
  "申请理由": "申请理由",
  "请输入申请理由": "请输入申请理由",
  "盈利总额": "盈利总额",
  "充值总额": "充值总额",
  "提现总额": "提现总额",
  "投注总额": "投注总额",
  "设置": "设置",
  "消息时间显示": "消息时间显示",
  "中奖提示": "中奖提示",
  "安静模式": "安静模式",
  "关于CG": "关于CG",
  "帮助与反馈": "帮助与反馈",
  "退出": "退出",
  "返水比例": "返水比例",
  "当日累计投注": "当日累计投注",
  "转运金": "转运金",
  "开元棋牌": "开元棋牌",
  "设置提现密码": "设置提现密码",
  "原密码": "原密码",
  "请输入当前密码": "请输入当前密码",
  "新密码": "新密码",
  "请输入新密码": "请输入新密码",
  "确认新密码": "确认新密码",
  "请再次输入密码": "请再次输入密码",
  "请输入旧密码": "请输入旧密码",
  "请输入正确的旧密码长度": "请输入正确的旧密码长度",
  "请输入正确的新密码长度": "请输入正确的新密码长度",
  "两次密码不一致": "两次密码不一致",
  "新旧密码不能一致": "新旧密码不能一致",
  "密码修改成功": "密码修改成功",
  "app下载": "app下载",
  "可扫描下发二维码进行app下载": "可扫描下发二维码进行app下载",
  "立即下载": "立即下载",
  "下载说明": "需在同一网络环境下下载安装注册，请勿切换网络； 若无法正常安装，请使用手机自带浏览器打开本页面",
  "请输入金额": "请输入金额",
  "转入": "转入",
  "平台钱包": "平台钱包",
  "操作金额不能为0": "操作金额不能为0",
  "转入成功": "转入成功",
  "天": "天",
  "时": "时",
  "分": "分",
  "秒": "秒",
  "剩余领取次数": "剩余领取次数",
  "次": "次",
  "主账号余额": "主账号余额",
  "账户充值": "账户充值",
  "账户提现": "账户提现",
  "下线转账": "下线转账",
  "订单号": "订单号",
  "金额": "金额",
  "空空如也": "空空如也",
  "今日": "今日",
  "近7日": "近7日",
  "近15日": "近15日",
  "近30日": "近30日",
  "转出": "转出",
  "赠送": "赠送",
  "反水": "反水",
  "未定义": "未定义",
  "待审核": "待审核",
  "审核通过": "审核通过",
  "审核拒绝": "审核拒绝",
  "失败": "失败",
  "成功": "成功",
  "待结算": "待结算",
  "全平台": "全平台",
  "大舞台": "大舞台",
  "官方动态": "官方动态",
  "动态": "动态",
  "活动申请记录": "活动申请记录",
  "活动标题": "活动标题",
  "申请时间": "申请时间",
  "状态": "状态",
  "未约定": "未约定",
  "通过": "通过",
  "拒绝": "拒绝",
  "派彩": "派彩",
  "无效注单": "无效注单",
  "已结算": "已结算",
  "未结算": "未结算",
  "返水中心": "返水中心",
  "返水记录": "返水记录",
  "点击领取": "点击领取",
  "累计领取": "累计领取",
  "待领取": "待领取",
  "返水金额": "返水金额",
  "返水时间": "返水时间",
  "领取时间": "领取时间",
  "暂未领取": "暂未领取",
  "暂无领取额度": "暂无领取额度",

  "加载中": "加载中",
  "最多支持添加5个地址": "最多支持添加5个地址",
  "认证失败": "认证失败",
  "您的账号登陆过期，请重新登陆": "您的账号登陆过期，请重新登陆",
  "提示": "提示",
  "您确定要退出登录吗": "您确定要退出登录吗",
  "精彩内容等你来体验，快来登录吧": "精彩内容等你来体验，快来登录吧",
  "立即下载APP": "立即下载APP",
  "余额": "余额",

  "活动详情": "活动详情",
  "活动说明": "活动说明",
  "立即申请": "立即申请",
  "前往登录": "前往登录",

  "代理系统": "代理系统",
  "下属代理": "下属代理",
  "代理总览": "代理总览",
  "直属玩家": "直属玩家",
  "盈亏统计": "盈亏统计",
  "账单查询": "账单查询",
  "充值记录": "充值记录",
  "提现记录": "提现记录",
  "个人信息": "个人信息",
  "下级在线": "下级在线",
  "我的余额": "我的余额",
  "附属代理人": "附属代理人",
  "附属玩家": "附属玩家",
  "今日投注": "今日投注",
  "今日收入": "今日收入",
  "历史收入": "历史收入",
  "邀请码": "邀请码",
  "开盘中": "开盘中",
  "已封盘": "已封盘",
  "下注倒计时": "下注倒计时",
  "期": "期",
  "期开奖结果": "期开奖结果",
  "已开启": "已开启",
  "已关闭": "已关闭",
  "期号": "期号",
  "号码": "号码",
  "总和": "总和",
  "总和两面": "总和两面",
  "首页": "首页",
  "上一页": "上一页",
  "下一页": "下一页",
  "尾页": "尾页",
  "请输入": "请输入",
  "下注": "下注",
  "选择": "选择",
  "大小单双": "大小单双",
  "大": "大",
  "小": "小",
  "单": "单",
  "双": "双",
  "大单": "大单",
  "大双": "大双",
  "小单": "小单",
  "小双": "小双",
  "形态": "形态",
  "豹子": "豹子",
  "对子": "对子",
  "顺子": "顺子",
  "极大": "极大",
  "极小": "极小",
  "特码": "特码",
  "清空": "清空",
  "立即下注": "立即下注",
  "开奖号码": "开奖号码",
  "第": "第",
  "投注时间": "投注时间",
  "投注金额": "投注金额",
  "玩法": "玩法",
  "盘类": "盘类",
  "派奖奖金": "派奖奖金",
  "赔率": "赔率",
  "双面玩法": "双面玩法",
  "特码玩法": "特码玩法",
  "倍": "倍",
  "投注积分": "投注积分",
  "请输入投注积分": "请输入投注积分",
  "返水": "返水",
  "总投注": "总投注",
  "有效投注": "有效投注",
  "实际盈利": "实际盈利",
  "两面": "两面",
  "组合": "组合",
  "每页": "每页",
  "条": "条",
  "编辑金额": "编辑金额",
  "恢复默认": "恢复默认",
  "保存": "保存",
  "距离开奖": "距离开奖",
  "刷新": "刷新",
  "返回": "返回",
  "当前第": "当前第",
  "数据统计详情": "数据统计详情",
  "值": "值",
  "未开期数": "未开期数",
  "单路区": "单路区",
  "间隔": "间隔",
  "咪牌": "咪牌",
  "投注区": "投注区",
  "游戏记录": "游戏记录",
  "路单区": "路单区",
  "游戏规则": "游戏规则",
  "开奖验证": "开奖验证",
  "开奖记录": "开奖记录",
  "统计": "统计",
  "大小": "大小",
  "极大小": "极大小",
  "已选": "已选",
  "注": "注",
  "共计": "共计",
  "已中奖": "已中奖",
  "未开奖": "未开奖",
  "已退款": "已退款",
  "语言": "语言",

  "六合彩": "六合彩",
  "初级": "初级",
  "猜特码": "猜特码",
  "猜特肖": "猜特肖",
  "猜平肖": "猜平肖",
  "猜类型": "猜类型",
  "平肖": "平肖",
  "鼠": "鼠",
  "牛": "牛",
  "虎": "虎",
  "兔": "兔",
  "龙": "龙",
  "蛇": "蛇",
  "马": "马",
  "羊": "羊",
  "猴": "猴",
  "鸡": "鸡",
  "狗": "狗",
  "猪": "猪",
  "类型": "类型",
  "蓝波": "蓝波",
  "绿波": "绿波",
  "红波": "红波",
  "特肖": "特肖",
  "特鼠": "特鼠",
  "特牛": "特牛",
  "特虎": "特虎",
  "特兔": "特兔",
  "特龙": "特龙",
  "特蛇": "特蛇",
  "特马": "特马",
  "特羊": "特羊",
  "特鸡": "特鸡",
  "特狗": "特狗",
  "特猪": "特猪",
  "特猴": "特猴",
  "什么也没有": "什么也没有",
  "进行中": "进行中",
  "已结束": "已结束",
  "快捷下注": "快捷下注",
  "开奖走势": "开奖走势",
  "开奖历史": "开奖历史",
  "在线": "在线",
  "快捷投注": "快捷投注",
  "项": "项",
  "需支付": "需支付",
  "确认投注": "确认投注",
  "错误提示": "错误提示",
  "管理员": "管理员",
  "封盘中": "封盘中",
  "预计盈利": "预计盈利",
  "投注成功": "投注成功",
  "用户": "用户",
  "时间": "时间",
  "投注": "投注",
  "MI28": "MI28",
  "中级": "中级",
  "新澳门六合彩": "新澳门六合彩",
  "澳门六合彩": "澳门六合彩",
  "下注内容": "下注内容",
  "合计总金额": "合计总金额",
  "房间": "房间",
  "投注详情": "投注详情",
  "输赢": "输赢",
  "开奖结果": "开奖结果",
  "当期总输赢": "当期总输赢",
  "开奖时间": "开奖时间",

  "更多新玩法等你来体验": "更多新玩法等你来体验",
  "精彩活动": "精彩活动",
  "代理联盟": "代理联盟",
  "始于成功": "始于成功",
  "臻于卓越": "臻于卓越",
  "鲤跃龙门": "鲤跃龙门",
  "投资传奇": "投资传奇",
  "VIP会员成长": "VIP会员成长",
  "晋级VIP会员": "晋级VIP会员",
  "享顶级至尊服务": "享顶级至尊服务",
  "确认添加": "确认添加",
  "iOS用户注意": "iOS用户注意",
  "充值打码量": "充值打码量",
  "全部": "全部",
  "划转": "划转",
  "协议的区别": "协议的区别",
  "开奖中": "开奖中",
  "新增USDT地址": "新增USDT地址",
  "新增银行卡": "新增银行卡",
  "本月存款": "本月存款",
  "游戏大厅": "游戏大厅",
  "玩法介绍": "玩法介绍",
  "账户": "账户",
  "赠送打码量": "赠送打码量",
  "搜索游戏名称": "搜索游戏名称",
  "请登录": "请登录",
  "红包已关闭": "红包已关闭",
  "已在当前页面": "已在当前页面",
  "马克六号彩票": "马克六号彩票",
  "PC28高赔率": "MI28高赔率",
  "PC28": "MI28",





  "发送的消息不能为空": "发送的消息不能为空",
  "19:56:30～20:29:30 为维护时间": "19:56:30～20:29:30 为维护时间",
  "23:55:30～00:05:00 为维护时间": "23:55:30～00:05:00 为维护时间",
  "本期已封盘": "本期已封盘",
  "发送成功": "发送成功",
  "请选择玩法": "请选择玩法",
  "请选择金额": "请选择金额",
  "恢复成功": "恢复成功",
  "价格不能为空值或0": "价格不能为空值或0",
  "价格不能有重复": "价格不能有重复",
  "持卡人姓名": "持卡人姓名",
  "请输入持卡人姓名": "请输入持卡人姓名",
  "为了您的资金能够迅速到账，请确保填写的姓名与银行卡的开户姓名一致": "为了您的资金能够迅速到账，请确保填写的姓名与银行卡的开户姓名一致",
  "请选择银行类型": "请选择银行类型",
  "请输入开户行": "请输入开户行",
  "请输入姓名": "请输入姓名",
  "请输入银行": "请输入银行",
  "请输人银行卡号": "请输人银行卡号",
  "请输人支付密码": "请输人支付密码",
  "请输人正确的卡号长度": "请输人正确的卡号长度",
  "请输人支付密码长度": "请输人支付密码长度",
  "绑定成功": "绑定成功",
  "USDT地址": "USDT地址",
  "请输入USDT地址": "请输入USDT地址",
  "请选择钱包协议": "请选择钱包协议",
  "赠送记录": "赠送记录",
  "选择开始日期": "选择开始日期",
  "选择结束日期": "选择结束日期",
  "输入账号": "输入账号",
  "昵称": "昵称",
  "赠送前": "赠送前",
  "赠送后": "赠送后",
  "赠送金额": "赠送金额",
  "到账状态": "到账状态",
  "直属代理": "直属代理",
  "自己": "自己",
  "请先选择开始时间": "请先选择开始时间",
  "团队总人数": "团队总人数",
  "团队总彩金": "团队总彩金",
  "团队总充值": "团队总充值",
  "团队总输赢": "团队总输赢",
  "团队总投注": "团队总投注",
  "团队纯利": "团队纯利",
  "团队福利": "团队福利",
  "新注册人数": "新注册人数",
  "首充人数": "首充人数",
  "团队返水": "团队返水",
  "团队拥金返水": "团队拥金返水",
  "六合盈亏": "六合盈亏",
  "金币": "金币",
  "总盈利": "总盈利",
  "直属": "直属",
  "所在房间": "所在房间",
  "代理": "代理",
  "暂无数据": "暂无数据",
  "MI28按照加拿大卑斯快乐8的开奖结果为基础": "MI28按照加拿大卑斯快乐8的开奖结果为基础",
  "每日官网维护时间是18:56-19:33": "每日官网维护时间是18:56-19:33",
  "每3.5分钟公布一次加拿大卑斯快乐8开奖结果": "每3.5分钟公布一次加拿大卑斯快乐8开奖结果",
  "排序后分别按号码": "排序后分别按号码",
  "第1-6，7-12，13-18分为【1】【2】【3】三个区": "第1-6，7-12，13-18分为【1】【2】【3】三个区",
  "赔率全新升级！ 单注1起，总注500000封顶。大小单双100000封顶。组合50000封顶。": "赔率全新升级！ 单注1起，总注500000封顶。大小单双100000封顶。组合50000封顶。",
  "特码20000封顶。2值10000封顶。 大小单双2.0倍（含本金）。【组合:小单/大双4.6倍；小双/大单4.2倍】（含本金）。": "特码20000封顶。2值10000封顶。 大小单双2.0倍（含本金）。【组合:小单/大双4.6倍；小双/大单4.2倍】（含本金）。",
  "注：大小单双开13/14特殊赔率": "注：大小单双开13/14特殊赔率",
  "总注：4999以内1.6倍（含本金）": "总注：4999以内1.6倍（含本金）",
  "总注：9999以内1.2倍（含本金）": "总注：9999以内1.2倍（含本金）",
  "总注：30000以上吃下注本金": "总注：30000以上吃下注本金",
  "组合：29999以内小单，大双 开13，14赔率回本（含本金）！": "组合：29999以内小单，大双 开13，14赔率回本（含本金）！",
  "组合：30000以上吃下注本金": "组合：30000以上吃下注本金",
  "豹子-顺子-对子-玩法": "豹子-顺子-对子-玩法",
  "豹子48倍": "豹子48倍",
  "顺子10倍": "顺子10倍",
  "对子3倍": "对子3倍",
  "极值15倍": "极值15倍",
  "回水规则": "回水规则",
  "1、负分3600.000-36000.000 需下注把数10吧 反百分之3": "1、负分3600.000-36000.000 需下注把数10吧 反百分之3",
  "2、负分36000.000-100000.000需下注把数10把 反百分之5": "2、负分36000.000-100000.000需下注把数10把 反百分之5",
  "3、负分100000.000需下注把数10把 反百分之8": "3、负分100000.000需下注把数10把 反百分之8",
  "【MI28】规则说明": "【MI28】规则说明",
  "1.大小玩法 数字14-27为大 数字0-13为小 。": "1.大小玩法 数字14-27为大 数字0-13为小 。",
  "2.单双玩法": "2.单双玩法",
  "数字1，3，5，~27为单 数字0，2，4~26为双。": "数字1，3，5，~27为单 数字0，2，4~26为双。",
  "3.极值玩法": "3.极值玩法",
  "极小：0，1，2，3，4，5": "极小：0，1，2，3，4，5",
  "极大：22，23，24，25，26，27": "极大：22，23，24，25，26，27",
  "举例：买极小 开奖结果为0-5其中一个数字就中奖，买极大开奖结果为22-27其中一个数字就中奖。": "举例：买极小 开奖结果为0-5其中一个数字就中奖，买极大开奖结果为22-27其中一个数字就中奖。",
  "4.组合玩法": "4.组合玩法",
  "* 数字14，16，~26为大双； 数字0，2，4，~12为小双。": "* 数字14，16，~26为大双； 数字0，2，4，~12为小双。",
  "* 数字15，17，~27为大单； 数字1，3，5，~13为小单。": "* 数字15，17，~27为大单； 数字1，3，5，~13为小单。",
  "5.定位玩法(单点数字玩法)": "5.定位玩法(单点数字玩法)",
  "从数字0-27中选取一个数字下注，如选取下注的数字与开奖如果相同，即为中奖。": "从数字0-27中选取一个数字下注，如选取下注的数字与开奖如果相同，即为中奖。",
  "6.波色": "6.波色",
  "* 绿波号码：1 , 4 , 7 , 10 , 16 , 19 , 22 , 25": "* 绿波号码：1 , 4 , 7 , 10 , 16 , 19 , 22 , 25",
  "* 蓝波号码：2 , 5 , 8 , 11 , 17 , 20 , 23 , 26": "* 蓝波号码：2 , 5 , 8 , 11 , 17 , 20 , 23 , 26",
  "* 红波号码：3 , 6 , 9 , 12 , 15 , 18 , 21 , 24": "* 红波号码：3 , 6 , 9 , 12 , 15 , 18 , 21 , 24",
  "* 当开奖结果为：0,13,14,27(所有买的波色皆输)视为全部不中奖！": "* 当开奖结果为：0,13,14,27(所有买的波色皆输)视为全部不中奖！",
  "7.豹子  顺子  对子": "7.豹子  顺子  对子",
  "当期3个开奖号码一致则中奖 , 如当期开奖结果为 3+3+3=9 则中奖豹子。": "当期3个开奖号码一致则中奖 , 如当期开奖结果为 3+3+3=9 则中奖豹子。",
  "当期3个开奖号码顺子则中奖，如当期开奖结果为 1+2+3=6 则中奖顺子。": "当期3个开奖号码顺子则中奖，如当期开奖结果为 1+2+3=6 则中奖顺子。",
  "当期3个开奖号码有两个一致中奖，如当期开奖结果为 0+2+2=4 则中奖对子。": "当期3个开奖号码有两个一致中奖，如当期开奖结果为 0+2+2=4 则中奖对子。",
  "已经是最后一页啦！": "已经是最后一页啦！",
  "用户名长度6~16位，以字母或数字组合！": "用户名长度6~16位，以字母或数字组合！",
  "请输入正确的密码长度，最少6位！": "请输入正确的密码长度，最少6位！",
  "密码错误，请重新输入": "密码错误，请重新输入",
  "账户登录": "账户登录",
  "请输入账号": "请输入账号",
  "验证码": "验证码",
  "记住密码": "记住密码",
  "跳过登录，先去逛逛": "跳过登录，先去逛逛",
  "新用户注册": "新用户注册",
  "请输入短信验证码": "请输入短信验证码",
  "获取验证码": "获取验证码",
  "切换线路": "切换线路",
  "请输入您的账号和密码！": "请输入您的账号和密码！",
  "OB电子": "OB电子",
  "FG电子": "FG电子",
  "PP电子": "PP电子",
  "AE电子": "AE电子",
  "始": "始",
  "开": "开",
  "包": "包",
  "红": "红",
  "离": "离",
  "距": "距",
  "束": "束",
  "结": "结",
  "完": "完",
  "抢": "抢",
  "已": "已",
  "已领取": "已领取",
  "当前最多可领取": "当前最多可领取",
  "快去满足条件吧！": "快去满足条件吧！",
  "活动时间": "活动时间",
  "累计充值金额": "累计充值金额",
  "红包次数": "红包次数",
  "领取规则": "领取规则",
  "抢到红包后，系统自动派彩，": "抢到红包后，系统自动派彩，",
  "秒到账": "秒到账",
  "，达到流水倍数即可取款；": "，达到流水倍数即可取款；",
  "2.领取红包条件：充值金额需要在规定的活动日期（美东时间）范围内，根据充值累计金额，获取抢红包次数，即可抢对应次数的红包；": "2.领取红包条件：充值金额需要在规定的活动日期（美东时间）范围内，根据充值累计金额，获取抢红包次数，即可抢对应次数的红包；",
  "南宫集团官网": "南宫集团官网",
  "注意": "注意",
  "抢红包": "抢红包",
  "北京时间为每天早上10点到12点，存款计算为前一天12点到今天10点，谢谢~": "北京时间为每天早上10点到12点，存款计算为前一天12点到今天10点，谢谢~",
  "每日百万现金红包！存款越多，机会越多，红包享不停，惊喜抢不停，还等什么？快快叫上好友一起分享吧！！": "每日百万现金红包！存款越多，机会越多，红包享不停，惊喜抢不停，还等什么？快快叫上好友一起分享吧！！",
  "1、会员必须在指定的活动日期（美东时间）范围内，根据充值累计金额，即可获得对应抢红包次数。若在规定的时间范围内没有达到存款金额范围，则不计算抢红包次数，逾期作废！": "1、会员必须在指定的活动日期（美东时间）范围内，根据充值累计金额，即可获得对应抢红包次数。若在规定的时间范围内没有达到存款金额范围，则不计算抢红包次数，逾期作废！",
  "2、所有的活动优惠特为玩家而设，如发现任何团体或个人，以不诚实的方式套取红利或任何威胁、滥用公司优惠等行为，公司保留冻结、取消该团体或个人账户及账户结余的权利。": "2、所有的活动优惠特为玩家而设，如发现任何团体或个人，以不诚实的方式套取红利或任何威胁、滥用公司优惠等行为，公司保留冻结、取消该团体或个人账户及账户结余的权利。",
  "3、金沙集团官网保留所有解释权，在任何时候都可以更改、停止、取消优惠活动。": "3、金沙集团官网保留所有解释权，在任何时候都可以更改、停止、取消优惠活动。",
  "当前时间段": "当前时间段",
  "活动还没开始，请静待活动开始。": "活动还没开始，请静待活动开始。",
  "请静待下次活动。": "请静待下次活动。",
  "恭喜您": "恭喜您",
  "抢到": "抢到",
  "立即充值": "立即充值",
  "您暂未达到领取条件，快去完成吧！": "您暂未达到领取条件，快去完成吧！",
  "服务器异常，请稍后再试": "服务器异常，请稍后再试",
  "软件APP": "软件APP",
  "按照": "按照",
  "到您的桌面": "到您的桌面",
  "安装": "安装",
  "请先登录": "请先登录",
  "PC彩票": "PC彩票",
  "万美元": "万美元",
  "现在就成为赢家": "现在就成为赢家",
  "开始": "开始",
  "最新投注": "最新投注",
  "最新": "最新",
  "日榜": "日榜",
  "周榜": "周榜",
  "月榜": "月榜",
  "经典": "经典",
  "百家乐": "百家乐",
  "快速": "快速",
  "大富翁": "大富翁",
  "财神驾到": "财神驾到",
  "红包派对": "红包派对",
  "沙巴体育": "沙巴体育",
  "UP体育": "UP体育",
  "德州扑克": "德州扑克",
  "21点": "21点",
  "抢庄牛牛": "抢庄牛牛",
  "巴沙体育": "巴沙体育",
  "游戏": "游戏",
  "玩家": "玩家",
  "倍数": "倍数",
  "返奖": "返奖",
  "更多": "更多",
  "热门": "热门",
  "即将上线，敬请期待": "即将上线，敬请期待",
  "立即投注": "立即投注",
  "游戏厂商": "游戏厂商",
  "183款游戏": "183款游戏",
  "千人在线畅玩": "千人在线畅玩",
  "最佳加密货币赌场 - 欢迎来到": "最佳加密货币赌场 - 欢迎来到",
  "home-detail-content": "探索加密游戏的终极目的地，这里每一笔交易都透明公开，每一个游戏都可验证公平性•MI28赌场结探索加密游戏的终极目的地，这里每一笔交易易都透明公开，每一个游戏都可验证公平性。MI28赌场结探索加密游戏的终极目的地，这里每一笔交易都透明公开，每一个游戏都可验证公平性•MI28赌场结",
  "收起更多": "收起更多",
  "查看更多": "查看更多",
  "支持/法律": "支持/法律",
  "常见问题": "常见问题",
  "负责任博彩": "负责任博彩",
  "公平公正": "公平公正",
  "服务条款": "服务条款",
  "隐私政策": "隐私政策",
  "关于我们": "关于我们",
  "支持的币种": "支持的币种",
  "赞助和博彩责任": "赞助和博彩责任",
  "introduce1": "MI28 由BETMGM LLC持有和运营，该公司在美国特拉华州注册，公司编 号 7061304，注册地址：美国新泽西州大西洋城的Marina District，依托美高梅度假村的线下资源开展线上业务。",
  "introduce2": "BetMGM在多个美国合规州及海外地区持有官方博彩运营牌照，部分公开可查的核心牌照如下",
  "introduce3": "新泽西州‌：由新泽西州博彩执法局颁发，许可证编号为NJIGP 000105-001，是其最早获得的核心运营牌照之一",
  "introduce4": "内华达州‌：由内华达州博彩控制委员会颁发，持有体育博彩全资质牌照",
  "introduce5": "‌英国‌：获得英国赌博委员会（UK Gambling Commission）颁发的远程博彩牌照，牌照编号为042596",
  "introduce6": "MI28致力于为所有用户提供安全、可靠、公平的游戏环境。无论 是下注、玩老虎机，还是参与真人或其他游戏活动，您都可以放心，MI28坚持诚信运营，为每位玩家提供卓越的游戏体验。",
  "尊敬的NG娱乐会员:": "尊敬的NG娱乐会员:",
  "我知道了": "我知道了",
  "如何安装": "如何安装",
  "1、使用Safar浏览器打开网站": "1、使用Safar浏览器打开网站",
  "2、点击分享图标": "2、点击分享图标",
  "3、选择“添加到主屏幕”": "3、选择“添加到主屏幕”",
  "添加到主屏幕": "添加到主屏幕",
  "期开奖": "期开奖",
  "账户余额": "账户余额",
  "封盘中禁止投注": "封盘中禁止投注",
  "请输入文字指令下注": "请输入文字指令下注",
  "发送": "发送",
  "信用投注": "信用投注",
  "共": "共",
  "合计": "合计",
  "最近投注": "最近投注",
  "投注确认": "投注确认",
  "游戏平台": "游戏平台",
  "免转模式": "免转模式",
  "额度转换": "额度转换",
  "平台账户余额": "平台账户余额",
  "游戏账户余额": "游戏账户余额",
  "操作金额": "操作金额",
  "填写操作金额": "填写操作金额",
  "转账方式": "转账方式",
  "提交": "提交",
  "充值信息": "充值信息",
  "请在": "请在",
  "内完成支付": "内完成支付",
  "成功付款后，将自动到账！": "成功付款后，将自动到账！",
  "如有问题，请": "如有问题，请",
  "确认": "确认",
  "收款地址": "收款地址",
  "交易时间": "交易时间",
  "充值方式": "充值方式",
  "充值完成": "充值完成",
  "资金明细": "资金明细",
  "支付方式": "支付方式",
  "银行卡": "银行卡",
  "余额充值": "余额充值",
  "请输入充值金额": "请输入充值金额",
  "充值限额：": "充值限额：",
  "请设置密码": "请设置密码",
  "注册并下载APP": "注册并下载APP",
  "两次密码不一样！": "两次密码不一样！",
  "请输入验证码！": "请输入验证码！",
  "验证码错误！": "验证码错误！",
  "注册失败": "注册失败",
  "获取验证码...": "获取验证码...",
  "请阅读并同意相关条款和隐私协议！": "请阅读并同意相关条款和隐私协议！",
  "两次密码不一致！": "两次密码不一致！",
  "请输入您的真实姓名!": "请输入您的真实姓名!",
  "请输入正确的支付密码长度，最少6位！": "请输入正确的支付密码长度，最少6位！",
  "卡片管理": "卡片管理",
  "虚拟币": "虚拟币",
  "最多支持添加5张银行卡": "最多支持添加5张银行卡",
  "确定要解除绑定该卡片吗？": "确定要解除绑定该卡片吗？",
  "解绑成功": "解绑成功",
  "(几分钟到数十分钟)": "(几分钟到数十分钟)",
  "(几秒到几分钟)": "(几秒到几分钟)",
  "*两种协议对应的USDT地址不互通，进行转账、充值等操作时，应仔细核对正确地址！": "*两种协议对应的USDT地址不互通，进行转账、充值等操作时，应仔细核对正确地址！",
  "1. 点击我的 (个人信息)": "1. 点击我的 (个人信息)",
  "1.第一次提现到数字货币时，请先绑定提币地址，绑定提币地址的步骤：": "1.第一次提现到数字货币时，请先绑定提币地址，绑定提币地址的步骤：",
  "1.请注意，注册时要求填写真实而准确的信息。": "1.请注意，注册时要求填写真实而准确的信息。",
  "2. 卡片管理": "2. 卡片管理",
  "2.用户使用网站前，请务必先阅读规则与条款，并确定已年满18岁。": "2.用户使用网站前，请务必先阅读规则与条款，并确定已年满18岁。",
  "2.输入提币金额，点击‘立即取款’，提币申请提交成功": "2.输入提币金额，点击‘立即取款’，提币申请提交成功",
  "2007-08赛季，尼克·杨代表奇才队出战75场常规赛比赛，场均得到7.5分、1.5个篮板。": "2007-08赛季，尼克·杨代表奇才队出战75场常规赛比赛，场均得到7.5分、1.5个篮板。",
  "2007年NBA选秀，尼克·杨在第一轮第16顺位被华盛顿奇才队选中。": "2007年NBA选秀，尼克·杨在第一轮第16顺位被华盛顿奇才队选中。",
  "2008-09赛季，由于奇才后场大将吉尔伯特·阿里纳斯的报销，尼克·杨获得了更多的机会，出战82场首发5次，场均得到10.9分。": "2008-09赛季，由于奇才后场大将吉尔伯特·阿里纳斯的报销，尼克·杨获得了更多的机会，出战82场首发5次，场均得到10.9分。",
  "2009-10赛季，奇才后场补充了兰迪·弗耶、迈克·米勒等优秀球员，抢占了尼克·杨的出场时间，尼克·杨出战74场比赛，场均得到8.6分": "2009-10赛季，奇才后场补充了兰迪·弗耶、迈克·米勒等优秀球员，抢占了尼克·杨的出场时间，尼克·杨出战74场比赛，场均得到8.6分",
  "3. 添加虚拟币地址": "3. 添加虚拟币地址",
  "3.提币审核成功后请登录交易网站或数字货币官方网站核实到账金额": "3.提币审核成功后请登录交易网站或数字货币官方网站核实到账金额",
  "4. 填写虚拟币地址信息": "4. 填写虚拟币地址信息",
  "5. 选择虚拟币提现/立即取款": "5. 选择虚拟币提现/立即取款",
  "6. 等待审核": "6. 等待审核",
  "ERC20-USDT地址以0x开头": "ERC20-USDT地址以0x开头",
  "ERC20协议": "ERC20协议",
  "ERC20：基于以太坊网络协议": "ERC20：基于以太坊网络协议",
  "Hi，欢迎进入{title}": "Hi，欢迎进入{title}",
  "TRC20-USDT地址以T开头": "TRC20-USDT地址以T开头",
  "TRC20协议": "TRC20协议",
  "TRC20的提币手续费最低，这意味着用户可以享受低手续费的交易所提币服务。同时，波场网络的TPS能够达到上千级别，可以实现交易秒级确认。": "TRC20的提币手续费最低，这意味着用户可以享受低手续费的交易所提币服务。同时，波场网络的TPS能够达到上千级别，可以实现交易秒级确认。",
  "TRC20：基于波场网络协议": "TRC20：基于波场网络协议",
  "Luka赞助内容": "sponsor_luka_content",
  "专属VIP体验": "专属VIP体验",
  "个人简介": "个人简介",
  "中等额度": "中等额度",
  "中等额度推荐": "中等额度推荐",
  "交易推荐": "交易推荐",
  "交易记录": "交易记录",
  "享受只属于你的与众不同": "享受只属于你的与众不同",
  "今日收益": "今日收益",
  "代理加盟": "代理加盟",
  "代理登录": "代理登录",
  "以太坊发行自己的原生代币及其他代币。但成千上万种代币的规则都不一样，这对后期市场发展非常不利。所以代币发行者做了一个智能合约标准，也就是ERC20。": "以太坊发行自己的原生代币及其他代币。但成千上万种代币的规则都不一样，这对后期市场发展非常不利。所以代币发行者做了一个智能合约标准，也就是ERC20。",
  "以太坊网络": "以太坊网络",
  "会员中心": "会员中心",
  "会员教程": "会员教程",
  "低": "低",
  "低手续费，秒级到账。": "低手续费，秒级到账。",
  "体育游戏规则": "体育游戏规则",
  "使用建议": "使用建议",
  "使用网络": "使用网络",
  "充值前": "充值前",
  "充值后": "充值后",
  "充值教程": "充值教程",
  "充值时间": "充值时间",
  "充值金额": "充值金额",
  "免责说明": "免责说明",
  "分享链接": "分享链接",
  "到底选哪种协议更好？": "到底选哪种协议更好？",
  "前往领取": "前往领取",
  "加入{title}第{days}天": "加入{title}第{days}天",
  "加入我们，共赢财富": "加入我们，共赢财富",
  "区别点": "区别点",
  "协议介绍": "协议介绍",
  "博彩责任": "博彩责任",
  "历史收益": "历史收益",
  "地址样式": "地址样式",
  "场馆余额": "场馆余额",
  "基本不堵": "基本不堵",
  "复制成功！": "复制成功！",
  "好友接受": "好友接受",
  "好友进行": "好友进行",
  "如何注册": "如何注册",
  "存款投注": "存款投注",
  "安全系数": "安全系数",
  "安全退出": "安全退出",
  "官方全球顶级合作伙伴": "官方全球顶级合作伙伴",
  "官方区域合作伙伴": "官方区域合作伙伴",
  "尊敬的会员用户": "尊敬的会员用户",
  "小额交易推荐": "小额交易推荐",
  "小额高频": "小额高频",
  "尤文图斯": "尤文图斯",
  "已领取次数": "已领取次数",
  "帮助中心": "帮助中心",
  "常规交易推荐": "常规交易推荐",
  "彩票投注规则": "彩票投注规则",
  "得分": "得分",
  "得分：{score}": "得分：{score}",
  "总投注额": "总投注额",
  "总资产": "总资产",
  "您的邀请": "您的邀请",
  "意见反馈": "意见反馈",
  "手机号码注册": "手机号码注册",
  "手机号码注册-输入手机号码，并验证码手机号码。": "手机号码注册-输入手机号码，并验证码手机号码。",
  "手续费和速度都介于中间值。": "手续费和速度都介于中间值。",
  "手续费用": "手续费用",
  "投注前": "投注前",
  "投注后": "投注后",
  "捕鱼": "捕鱼",
  "提现前，请先确保您已成功登录账号。": "提现前，请先确保您已成功登录账号。",
  "提现教程": "提现教程",
  "早上好，欢迎来到帮助中心": "早上好，欢迎来到帮助中心",
  "时间排行榜": "时间排行榜",
  "时间：{time}": "时间：{time}",
  "普通": "普通",
  "更多公告": "更多公告",
  "有效流水": "有效流水",
  "期数": "期数",
  "未登录": "未登录",
  "条款协议内容": "条款协议内容",
  "极快": "极快",
  "欢迎来到{title}": "欢迎来到{title}",
  "欢迎来到平台，我们致力于通过精良的技术、前卫的产品，成为亚洲博彩业的领导品牌": "欢迎来到平台，我们致力于通过精良的技术、前卫的产品，成为亚洲博彩业的领导品牌",
  "步骤如下": "步骤如下",
  "永久域名": "永久域名",
  "没有找到解决办法？请联系": "没有找到解决办法？请联系",
  "波场网络": "波场网络",
  "活动时间: 长期有效": "活动时间: 长期有效",
  "活动记录": "活动记录",
  "游戏排行榜": "游戏排行榜",
  "游戏规则_体育内容": "<div class=\"sports-games-article\"><div class=\"main-container-title\">一般体育规则</div><div class=\"main-container-content\"><p>所有投注须遵守平台规则与条款，请在投注前查看具体玩法。赛事取消或延期时，注单将按对应规则处理。</p><ol><li>提交前请仔细检查投注选项。</li><li>投注提交后不可修改或取消。</li><li>官方赛果和平台记录作为结算依据。</li><li>滚球遇到重大事件时可能延迟确认或拒绝。</li></ol></div></div>",
  "游戏规则_彩票内容": "<div class=\"lottery-games-article\"><div class=\"main-container-title\">彩票投注规则</div><div class=\"main-container-content\"><p>彩票玩法以官方开奖结果结算，请在投注前查看玩法定义、封盘时间和赔付条件。</p><p>取消、延期或无效开奖按对应玩法规则处理。</p></div></div>",
  "游戏规则_电子游戏内容": "<div class=\"electron-games-article\"><div class=\"main-container-title\">电子游戏规则</div><div class=\"main-container-content\"><p>{brand}电子游戏使用经认证的随机结果，请理性娱乐并在投注前查看赔付表。</p><p>赛果按照页面展示规则和平台记录结算。</p></div></div>",
  "游戏规则_真人内容": "<div class=\"immortal-games-article\"><div class=\"main-container-title\">真人娱乐规则</div><div class=\"main-container-content\"><p>轮盘、百家乐和骰宝由真人荷官主持。请选择玩法，在封盘前提交投注并等待官方赛果。</p><p>各桌的规则、赔率和结算条件以页面展示为准。</p></div></div>",
  "电子游戏规则": "电子游戏规则",
  "登录后查看": "登录后查看",
  "登录平台-个人信息-卡片管理-添加数字货币地址": "登录平台-个人信息-卡片管理-添加数字货币地址",
  "真人娱乐规则": "真人娱乐规则",
  "真人娱乐，体育投注，电子游艺等尽在一手掌握": "真人娱乐，体育投注，电子游艺等尽在一手掌握",
  "福利中心": "福利中心",
  "立享会员特权": "立享会员特权",
  "立即登录": "立即登录",
  "第一步：在网站或App上直接点击注册；": "第一步：在网站或App上直接点击注册；",
  "第三步：按照提示填写资料；": "第三步：按照提示填写资料；",
  "第三步：设置账户昵称": "第三步：设置账户昵称",
  "第二步：按照提示填写资料；": "第二步：按照提示填写资料；",
  "第二步：按照提示填写资料；；": "第二步：按照提示填写资料；；",
  "第五步：注册成功。": "第五步：注册成功。",
  "第四步：注册成功": "第四步：注册成功",
  "第四步：设置账户昵称。": "第四步：设置账户昵称。",
  "等级": "等级",
  "等级排行榜": "等级排行榜",
  "等级：{level}": "等级：{level}",
  "红包记录": "红包记录",
  "红包金额": "红包金额",
  "经常拥堵": "经常拥堵",
  "给你好友": "给你好友",
  "网络状态": "网络状态",
  "联系我们": "联系我们",
  "至": "至",
  "若相关问题仍未解决，可咨询在线客服": "若相关问题仍未解决，可咨询在线客服",
  "虚拟币提现": "虚拟币提现",
  "虚拟币支付": "虚拟币支付",
  "设置登录密码。": "设置登录密码。",
  "豪礼赠送": "豪礼赠送",
  "账户名注册": "账户名注册",
  "账户名注册-输入账户名和密码。。": "账户名注册-输入账户名和密码。。",
  "账户设置": "账户设置",
  "购买虚拟币": "购买虚拟币",
  "赞助": "赞助",
  "赞助信息": "赞助信息",
  "转账速度": "转账速度",
  "退出系统": "退出系统",
  "选择数字货币": "选择数字货币",
  "邀请有好礼 红包等你": "邀请有好礼 红包等你",
  "阿斯顿维拉": "阿斯顿维拉",
  "隐私政策提示": "隐私政策提示",
  "高": "高",
  "1. 打开并登录欧意APP": "1. 打开并登录欧意APP",
  "1. 选择数字货币": "1. 选择数字货币",
  "2. 输入充值金额": "2. 输入充值金额",
  "2. 选择快捷买币": "2. 选择快捷买币",
  "3. 复制地址或进行扫码": "3. 复制地址或进行扫码",
  "3. 点击去购买": "3. 点击去购买",
  "4. 打开并登录欧易软件": "4. 打开并登录欧易软件",
  "4. 输入购买金额": "4. 输入购买金额",
  "5. 可持续二次购买": "5. 可持续二次购买",
  "5. 进入“资金”选择“提现”": "5. 进入“资金”选择“提现”",
  "6. 选择USDT币种": "6. 选择USDT币种",
  "7. 点击提交按钮": "7. 点击提交按钮",
  "VIP收益": "VIP收益",
  "参与期数": "参与期数",
  "团队俑金返水": "团队俑金返水",
  "团队彩金": "团队彩金",
  "团队总剩余": "团队总剩余",
  "团队总提现": "团队总提现",
  "团队总流水": "团队总流水",
  "团队总盈利": "团队总盈利",
  "团队退水": "团队退水",
  "当前游戏无房间": "当前游戏无房间",
  "条款与规则": "条款与规则",
  "消息": "消息",
  "玩家详情": "玩家详情",
  "虚拟货币支付": "虚拟货币支付",
  "返点收益": "返点收益",
  "香港六合彩": "香港六合彩",
  "AG真人": "AG Casino",
  "AG电子": "AG Electronic",
  "BG真人": "BG Casino",
  "FB体育": "FB Sports",
  "KY棋牌": "KY Chess",
  "PG电子": "PG Slots",
  "专业模式": "专业模式",
  "群控模式": "群控模式",
  "进入游戏": "进入游戏",
  "大厅选择": "大厅选择",
  "选择房间": "选择房间",
  "房间规则": "房间规则",
  "新手推荐": "新手推荐",
  "最热门": "最热门",
  "VIP专属": "VIP专属",
  "MI28-中级": "MI28-中级",
  "MI28-高级": "MI28-高级",
  "MI28-5分钟": "MI28-5分钟",
  "MI28-5分钟-中级": "MI28-5分钟-中级",
  "MI28-5分钟-高级": "MI28-5分钟-高级",
  "房间规则1": "1.VIP1厅适合新手入门体验",
  "房间规则2": "2.VIP2厅赔率更高，适合进阶玩家",
  "房间规则3": "3.VIP3厅享受最高赔率和专属服务",
  "分钟": "分钟"
}



// WEBPACK FOOTER //
// ./src/locales/lang/zh.js